import type { components } from '../generated-types'
import type { PaginationParams } from '../types'

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  BANNED = 'BANNED',
  DEACTIVATED = 'DEACTIVATED',
}

export interface User {
  id: string
  username: string
  name: string
  email: string
  phone: string | null
  avatarUrl: string | null
  coverUrl?: string | null
  isVerified: boolean
  type: 'REGULAR' | 'STAFF'
  accountStatus: AccountStatus
  emailVerified: boolean
  phoneVerified: boolean
  isSuperAdmin: boolean
  isBot: boolean
  lastLoginAt: string | null
  lastLoginIp: string | null
  suspendedUntil: string | null
  bannedAt: string | null
  banReason: string | null
  roles: Array<{ id: string; name: string; assignedAt: string }>
  permissions?: string[]
  createdAt: string
  updatedAt: string | null
}

export interface GetUsersParams extends PaginationParams {
  accountStatus?: AccountStatus | AccountStatus[]
  emailVerified?: boolean
  phoneVerified?: boolean
  username?: string
  query?: string
}

export interface CreateUserRequest {
  email: string
  name: string
  password: string
  role: string[]
}

export type UpdateUserRequest = components['schemas']['UpdateUserDto'] & { email?: string; role?: string[] }
export type UserActivity = components['schemas']['UserActivityDataDto']
export type GenerateUserUploadUrlDto = components['schemas']['GenerateUserUploadUrlDto']

export interface GenerateUserUploadUrlResponse {
  originalUrl: string
  originalKey: string
  type: 'IMAGE' | 'VIDEO' | 'GIF'
  publicUrl: string
}
